import * as actionTypes from '../actions/actionTypes';
import { ClientList } from '../types/ClientList';

const initalState: ClientList = {
  clientData: { clients: [], totalPages: 0 },
  masterClientsData: [],
  pageNumber: 1,
  itemsPerPage: 10,
  addClientResponse: null,
  newClient: {
    clientName: '',
    clientAddress: '',
    userName: '',
    email: '',
    mobile: {
      countryCode: '',
      number: '',
    },
    moduleAccess: [
      {
        type: 'module',
        name: 'goal',
        isAllowed: true,
      },
      {
        type: 'module',
        name: 'course',
        isAllowed: true,
      },
      {
        type: 'module',
        name: 'content',
        isAllowed: true,
      },
      {
        type: 'module',
        name: 'user',
        isAllowed: true,
      },
      {
        type: 'module',
        name: 'edp',
        isAllowed: true,
      },
    ],
  },
  clientName: '',
  editClientResponse: null,
  editClient: {
    name: '',
    address: '',
    license: {
      type: '',
    },
    access: [],
    adminsData: [],
  },
  clientId: '',
  licenseExpiredDialog: {
    showDialog: false,
    configuration: null,
  },
  moduleAccessDialog: {
    showDialog: false,
    configuration: null,
  },
  errorMessageToast: {
    showDialog: false,
    configuration: null,
  },
  formErrors: {
    name: 'valid',
    address: 'valid',
    fullName: 'valid',
    email: 'valid',
    number: 'valid',
    empCode: 'valid',
  },
  editFormErrors: {
    name: 'valid',
    address: 'valid',
    fullName: 'valid',
    email: 'valid',
    number: 'valid',
    empCode: 'valid',
  },
  clientAddedSuccessfully: false,
  isIniitated: false,
  clientEditedSuccessfully: false,
  searchQuery: '',
  searchQueryByTab: {
    clientTab: '',
    usersTab: '',
    rolesTab: ''
  }
};

const clientReducer = (state = initalState, action: any) => {
  switch (action.type) {
    case actionTypes.GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clientData: action.payload,
      };
    case actionTypes.GET_MASTER_CLIENTS_SUCCESS:
      return {
        ...state, 
        masterClientsData: action.payload
      }
    case actionTypes.GET_CLIENT_SUCCESS:
      console.log('SEARCH QUERY', action.payload)
      return {
        ...state,
        editClient: action.payload.clients[0],
      };
    case actionTypes.GET_NEXT_CLIENT_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case actionTypes.GET_PREV_CLIENT_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case actionTypes.GET_FIRST_CLIENT_PAGE:
      return {
        ...state,
        pageNumber: 1,
      };
    case actionTypes.GET_LAST_CLIENT_PAGE:
      return {
        ...state,
        // TODO
      };
    case actionTypes.IS_LOADING_TRUE:
      return {
        ...state,
        isIniitated: true
      }
    case actionTypes.IS_LOADING_FALSE:
      return {
        ...state,
        isIniitated: false
      }
    case actionTypes.ADD_CLIENT:
      return {
        ...state,
        newClient: action.payload,
      };
    case actionTypes.ADD_CLIENT_SUCCESS:
      let resetFormErrors = {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      };
      return {
        ...state,
        formErrors: resetFormErrors,
        clientAddedSuccessfully: true,
      };
    case actionTypes.ADD_CLIENT_FAILURE:
      let updatedFormErrors = {
        name: '',
        address: '',
        fullName: '',
        email: '',
        number: '',
        empCode: '',
      };
      
      if (
        action.payload.responseObject.message.includes(
          'A Client already exists'
        )
      ) {
        updatedFormErrors.name = 'A Client already exists with that name.';
      } else if (action.payload.responseObject.message.includes('Email')) {
        updatedFormErrors.email = 'Email Id already in use.';
      } else if (action.payload.responseObject.message.includes('Mobile')) {
        updatedFormErrors.number = 'Mobile number already in use.';
      } else if (action.payload.responseObject.message.includes('address')) {
        updatedFormErrors.address =
          'Client address should be of atleast 5 characters.';
      } else if (
        action.payload.responseObject.message.includes(
          'Please enter at least 3 characters for client admin name.'
        )
      ) {
        updatedFormErrors.fullName =
          'Client name should be of atleast 3 characters.';
      } else {
      }

      
      return {
        ...state,
        formErrors: updatedFormErrors,
        clientAddedSuccessfully: false,
      };
    case actionTypes.ADD_CLIENT_TOAST_CLOSE:
      return {
        ...state,
        clientAddedSuccessfully: false,
      };
    case actionTypes.ADD_CLIENT_CORRECTION:
      let updatedFormErrorsCorrection = {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      };
      return {
        ...state,
        formErrors: updatedFormErrorsCorrection,
      };
    case actionTypes.CHECK_IF_CLIENT_EXISTS:
      return {
        ...state,
        clientName: action.payload,
      };
    case actionTypes.EDIT_CLIENT_SUCCESS:
      
      let resetEditFormErrors = {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      };
      return {
        ...state,
        editFormErrors: resetEditFormErrors,
        clientEditedSuccessfully: true,
      };
    case actionTypes.EDIT_CLIENT_FAILURE: 
    
      let updatedEditFormErrors = {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      };

      if (action.payload.responseObject.message.includes('Email')) {
        updatedEditFormErrors.email = 'Email Id updating in use.';
      } else if (
        action.payload.responseObject.message.includes('Client already')
      ) {
        updatedEditFormErrors.name = 'A Client already exists with that name.';
      } else if (action.payload.responseObject.message.includes('Mobile')) {
        updatedEditFormErrors.number = 'Mobile number already in use.';
      } else if(action.payload.responseObject.message.includes('primary client')){
        updatedEditFormErrors.email = action.payload.responseObject.message;
      }
      return {
        ...state,
        editFormErrors: updatedEditFormErrors,
        clientEditedSuccessfully: false,
      };

    case actionTypes.EDIT_CLIENT_TOAST_CLOSE:
      return {
        ...state,
        clientEditedSuccessfully: false,
      };

    case actionTypes.EDIT_CLIENT_CORRECTION:
      let editFormErrorsCorrection = {
        name: 'valid',
        address: 'valid',
        fullName: 'valid',
        email: 'valid',
        number: 'valid',
        empCode: 'valid',
      };
      return {
        ...state,
        editFormErrors: editFormErrorsCorrection,
      };

    case actionTypes.SHOW_LICENSE_EXPIRED_DIALOG:
      return {
        ...state,
        licenseExpiredDialog: action.payload,
      };
    case actionTypes.SHOW_MODULE_ACCESS_DIALOG:
      return {
        ...state,
        moduleAccessDialog: action.payload,
      };
    case actionTypes.SHOW_ERROR_MESSAGE_TOAST:
      return {
        ...state,
      };
    case actionTypes.SEARCH_CLIENTS_SUCCESS:
      const { res, requestObject} = action.payload;
      return {
        ...state,
        clientData: res,
        searchQuery: requestObject.searchQuery
      }
    case actionTypes.SET_SEARCH_QUERY_BY_TAB:
      const { searchText, tab } = action.payload;
      let updatedSearchQueryByTab = {...state.searchQueryByTab};
      switch(tab){
        case 'Clients':
          updatedSearchQueryByTab.clientTab = searchText;
        case 'Roles':
          updatedSearchQueryByTab.rolesTab = searchText;
        case 'Users':
          updatedSearchQueryByTab.usersTab = searchText;
        default:
      }
      return {
        ...state,
        searchQueryByTab: updatedSearchQueryByTab
      }
    case actionTypes.CLEAR_SEARCH_QUERY_TEXT:
      return {
        ...state,
        searchQuery: ''
      }
    default:
      return state;
  }
};

export default clientReducer;
